import { IHttpResponse, post, put } from './BackendService';
import { getAuth, putAuth } from './AuthHttpService';
import { DevPortalResources } from '../interfaces/DevPortalResources';
import { DevPortalTestingAccount, IUser } from '../interfaces/user';
import { CreateAppResponse, QuickAppResponse, QuickAppType } from '../interfaces/quickApp';
import { authHeader } from '../helpers/auth-header';
import { Organisation } from '../interfaces/organisation.interface';
import { PROJECT_STATUS } from '../interfaces/project';
import { DeviceInterface } from '../components/Devices/device.interface';
import { ApplicationInterface, ApplicationManagerInterface } from '../interfaces/application';
import { DEV_PORTAL_API_URL } from '../app-config';

export const getResources = async (): Promise<IHttpResponse<DevPortalResources[]>> =>
  getAuth<DevPortalResources[]>(`${DEV_PORTAL_API_URL}/api/resources`);

export const getTestingAccount = async (): Promise<IHttpResponse<DevPortalTestingAccount[]>> =>
  getAuth<DevPortalTestingAccount[]>(`${DEV_PORTAL_API_URL}/api/developer/test-accounts`);

export const quickStartApp = async (body: QuickAppType): Promise<IHttpResponse<QuickAppResponse>> =>
  post(`${DEV_PORTAL_API_URL}/api/v1/quick-app`, body, {
    method: 'post',
    body: JSON.stringify(body),
    headers: authHeader(),
  });

export const updateApp = async (
  body: any,
  id?: string,
): Promise<IHttpResponse<CreateAppResponse>> =>
  post(`${DEV_PORTAL_API_URL}/api/v1/app/${id}`, body, {
    method: 'put',
    body: JSON.stringify(body),
    headers: authHeader(),
  });

export const fetchOrg = async (): Promise<IHttpResponse<Organisation>> =>
  getAuth(`${DEV_PORTAL_API_URL}/api/organisation`, {
    headers: authHeader(),
  });

export const updateOrg = async (body: any, id: string): Promise<IHttpResponse<Organisation>> =>
  put(`${DEV_PORTAL_API_URL}/api/v1/organisations/${id}`, body, {
    method: 'put',
    body: JSON.stringify(body),
    headers: authHeader(),
  });

export const submitSupportRequest = async (body: any): Promise<IHttpResponse<any>> =>
  post(`${DEV_PORTAL_API_URL}/api/v1/supportEmail`, body, {
    method: 'post',
    body: JSON.stringify(body),
    headers: authHeader(),
  });

export const listDevices = async (): Promise<IHttpResponse<ApplicationInterface[]>> =>
  getAuth(`${DEV_PORTAL_API_URL}/api/developer/apps?kind=device`, {
    headers: authHeader(),
  });

export const createDeviceApp = async (): Promise<IHttpResponse<DeviceInterface>> =>
  post(
    `${DEV_PORTAL_API_URL}/api/v1/device-app`,
    {},
    {
      method: 'post',
      headers: authHeader(),
    },
  );

export const refreshDeviceAppSecret = async (
  deviceId: string,
): Promise<IHttpResponse<DeviceInterface>> =>
  putAuth(
    `${DEV_PORTAL_API_URL}/api/v1/device-app/${deviceId}`,
    {},
    {
      method: 'put',
      headers: authHeader(),
    },
  );

export const listAdminAvailableUsers = async (
  take: number,
  skip: number,
): Promise<IHttpResponse<IUser[]>> =>
  getAuth<IUser[]>(`${DEV_PORTAL_API_URL}/api/admin/users?take=${take}&skip=${skip}`);

export const listAdminAvailableProjects = async (
  take: number,
  skip: number,
): Promise<IHttpResponse<ApplicationManagerInterface[]>> =>
  getAuth<ApplicationManagerInterface[]>(
    `${DEV_PORTAL_API_URL}/api/manager/apps?take=${take}&skip=${skip}`,
  );

export const getAdminProjectById = async (
  applicationId: string,
): Promise<IHttpResponse<ApplicationManagerInterface>> =>
  getAuth<ApplicationManagerInterface>(`${DEV_PORTAL_API_URL}/api/manager/apps/${applicationId}`);

export const changeAppStatus = async (
  applicationId: string,
  newStatus: PROJECT_STATUS,
  body?: { reason: string },
): Promise<IHttpResponse<CreateAppResponse>> =>
  putAuth<CreateAppResponse>(
    `${DEV_PORTAL_API_URL}/api/v1/app/${applicationId}/status/${newStatus}`,
    body,
  );

export const getDeveloperApp = async (
  appId: string,
): Promise<IHttpResponse<ApplicationInterface>> =>
  getAuth<ApplicationInterface>(`${DEV_PORTAL_API_URL}/api/developer/apps/${appId}`);
